import request from '@/utils/httpRequest'

export function getExhibitList (query) {
  return request({
    url: 'api/portal/web/exhibit/page',
    method: 'get',
    params: query
  })
}

export function getExhibitdetail (id) {
  return request({
    url: '/api/portal/web/exhibit/' + id,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/exhibit/index.js